import { render } from "./RecommendList.vue?vue&type=template&id=2a3a8c93&scoped=true"
import script from "./RecommendList.vue?vue&type=script&lang=js"
export * from "./RecommendList.vue?vue&type=script&lang=js"

import "./RecommendList.vue?vue&type=style&index=0&id=2a3a8c93&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3a8c93"]])

export default __exports__